// extracted by mini-css-extract-plugin
module.exports = {"container":"b4f049ad","row":"_0c22ad84","person":"eb8edf43","hidden":"_16bcb3c7"};